import { WithAuthorization } from "../../context";
import { Card } from "../../components/Card";
import { Center, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import Page from "../../components/Page/Page";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Decarbonization } from "../Decarbonization";
import { CarbonPricingFinancialModel } from "../ScenarioPlanning/components/CarbonPrice/components";

function NetZeroStrategy() {
  const { t } = useTranslation("translation", {
    keyPrefix: "netZeroStrategy"
  });

  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Page title={t("page.title")} subTitle={t("page.subTitle")}>
      <Card>
        <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex}>
          <Center>
            <TabList borderBottom="none">
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.carbonPricingFinancialModel")}</Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.decarbonisation")}</Tab>
            </TabList>
          </Center>
          <TabPanels>
            <TabPanel padding="0">
              <CarbonPricingFinancialModel />
            </TabPanel>
            <TabPanel padding="0">
              <Decarbonization />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </Page>
  );
}

export default WithAuthorization(NetZeroStrategy);